import React from "react";
import "./pages.css";
import Button from "../Components/BasicComponents/Button";
import heroImage from "../Assets/Images/Hero/hourglass.svg";
import {UseCaseList} from "../Components/Contents/UseCaseList";
import {DefaultParameters} from "../Api/ApiCallMethod";
import MetaData from "../Components/MetaData/MetaData";
import Icon from "../Assets/IconLibrary/Icon";
import {Link} from "react-router-dom";
import {MyTooltip} from "../Components/BasicComponents/Tooltip";


export default class Home extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            benefitList: [
                {
                    Name: "Accurate",
                    Icon: "accurate"
                },
                {
                    Name: "Fast",
                    Icon: "fast"
                },
                {
                    Name: "Confidential",
                    Icon: "confidential"
                },
                {
                    Name: "Secure",
                    Icon: "secure"
                },
            ]
        }
    }

    onSignUp = () => {
        let productUrl = DefaultParameters().ProductURL
        productUrl += DefaultParameters().LoginRoute
        window.open(productUrl, '_blank');
    }

    openUseCaseDetails = (id) => {
        let {setUseCaseID, scrollToTop, openDetailPage} = this.props;
        setUseCaseID(id);
        scrollToTop();
        openDetailPage();
    }

    render() {
        let {benefitList} = this.state;

        return (
            <div className="home-layout">
                <MetaData keyword={"home"}/>
                <div className="hero-section">
                    <div className="hero-section--left">
                        <h1 className="header-text hero-title">
                            Agentic AI Platform for Patents
                        </h1>
                        <div className="hero-benefit-row">
                            {
                                benefitList.map((benefitInfo,bid)=>
                                    <div className="hero-benefit-item" key={bid}>
                                        <Icon name={benefitInfo.Icon} size={24} className="hero-benefit-item-icon"/>
                                        <div className="hero-benefit-item-name">
                                            {benefitInfo.Name}
                                        </div>
                                    </div>
                                )
                            }
                        </div>
                        <div className="landing-use-case-list">
                            {
                                Object.keys(UseCaseList).map((useCaseInfo, uid) =>
                                    <MyTooltip
                                        maxWidth={400} isArrow={false
                                    } title={
                                        <div className="landing-use-case-tooltip">
                                            <div className="landing-use-case-tooltip-text">
                                                {UseCaseList[useCaseInfo].SubHeader}
                                            </div>
                                        </div>}>
                                        <Link className="landing-use-case-item"
                                              key={uid}
                                              to={`/${UseCaseList[useCaseInfo].LinkName}`}
                                              onClick={this.openUseCaseDetails.bind(this, useCaseInfo)}>
                                            <Icon name={UseCaseList[useCaseInfo].Icon} size={20} className="lading-use-case-icon"/>
                                            <div className="landing-use-case-item-text">
                                                {UseCaseList[useCaseInfo].Name}
                                            </div>
                                        </Link>
                                    </MyTooltip>
                                )
                            }

                        </div>

                        <div className="hero-button-row">
                            <Button type={"primary"} onClick={this.onSignUp.bind(this)}>
                                Get Started
                            </Button>
                        </div>



                    </div>
                    <div className="hero-section--right">
                        <div className="hero-image">
                            <img src={heroImage}
                                 width={"100%"}
                                 alt={"Illustration of an hourglass from IP Agent AI showing the transformation of traditional, manual patent workflows filled with paperwork, delays, and inefficiencies at the top into streamlined AI-powered processes at the bottom. The lower section highlights IP Agent AI’s patent drafting AI copilot, prior art search AI, AI patent analytics platform, automated patent analysis, AI patent quality check, and patent prosecution AI, enabling IP professionals to achieve better patents faster with precision and efficiency"}/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}